import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "item", "destroy"]

  add() {
    const index = Date.now().toString()
    this.listTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replaceAll("NEW_RECORD", index))
  }

  remove(event) {
    const item = event.target.closest("[data-work-items-target='item']")
    const destroyField = item.querySelector("[data-work-items-destroy-target='field']")
    if (destroyField) destroyField.value = "1"
    item.hidden = true
  }
}
